import { useCallback, useMemo } from "react"

import { ChipList } from "@l2r-front/l2r-ui"

import { useVerticalSigningDispatchContext, useVerticalSigningStateContext } from "../../contexts/VerticalSigningContext"

export function TagsFilterList(props) {

    const { filters } = useVerticalSigningStateContext()
    const { setFilters } = useVerticalSigningDispatchContext()

    const displayedFilters = useMemo(() => {
        const tagsFilters = filters.tags.map((filterValue, i) => ({
            color: "primary",
            key: "tags",
            index: i,
            label: filterValue,
            value: filterValue,
        }))
        const antiTagsFilters = filters.antiTags.map((filterValue, i) => ({
            color: "action/darkRed",
            key: "antiTags",
            index: i,
            label: filterValue,
            value: filterValue,
        }))
        return [...tagsFilters, ...antiTagsFilters]
    }, [filters])

    const deleteFilter = useCallback((filter) => {
        const tagsFilters = filters?.tags
        const antiTagsFilters = filters?.antiTags

        if (filter.key === "antiTags") {
            antiTagsFilters.splice(filter.index, 1)
            return setFilters({
                "antiTags": antiTagsFilters,
            })
        } else {
            tagsFilters.splice(filter.index, 1)
            setFilters({
                "tags": tagsFilters,
            })
        }
    }, [filters, setFilters])

    if (filters?.tags?.length || filters?.antiTags?.length) {
        return <ChipList
            {...props}
            onDelete={deleteFilter}
            values={displayedFilters}
            variant="filled"
        />
    }
    return null
}
